import { render, staticRenderFns } from "./ContaRecorrente.vue?vue&type=template&id=028dca42&scoped=true&"
import script from "./ContaRecorrente.vue?vue&type=script&lang=js&"
export * from "./ContaRecorrente.vue?vue&type=script&lang=js&"
import style0 from "./ContaRecorrente.vue?vue&type=style&index=0&id=028dca42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028dca42",
  null
  
)

export default component.exports